import styles from '../layout/page.module.css';

interface SortableTableHeaderProps {
  label: string;
  column: string;
  activeColumn: string;
  direction: 'asc' | 'desc';
  onSort: (column: string) => void;
  className?: string;
}

/** A table heading that exposes its sort state to both mouse and keyboard users. */
export function SortableTableHeader({
  label,
  column,
  activeColumn,
  direction,
  onSort,
  className,
}: SortableTableHeaderProps) {
  const isActive = activeColumn === column;
  const nextDirection = isActive && direction === 'asc' ? 'malejąco' : 'rosnąco';

  return (
    <th className={className} aria-sort={isActive ? (direction === 'asc' ? 'ascending' : 'descending') : 'none'}>
      <button
        type="button"
        className={styles.sortHeader}
        onClick={() => onSort(column)}
        aria-label={`Sortuj: ${label}, ${nextDirection}`}
      >
        <span>{label}</span>
        <span className={styles.sortIndicator} aria-hidden="true">
          {isActive ? (direction === 'asc' ? '↑' : '↓') : '↕'}
        </span>
      </button>
    </th>
  );
}
